import AuthSelector_default from "./components/AuthSelector.vue.js";
export { AuthSelector_default as AuthSelector };
